const utf8ToBase64Url = (str: string): string => {
  const bytes = new TextEncoder().encode(str);
  const binaryStr = Array.from(bytes, byte => String.fromCharCode(byte)).join('');
  return btoa(binaryStr).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
};

export const createUnsignedJWT = (payload: object): string => {
  const header = { alg: 'none', typ: 'JWT' };
  const base64Header = utf8ToBase64Url(JSON.stringify(header));
  const base64Payload = utf8ToBase64Url(JSON.stringify(payload));
  return `${base64Header}.${base64Payload}.`;
};

export const parseJWT = <T = Record<string, unknown>>(token: string): T | null => {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const binaryStr = atob(padded);
    const bytes = Uint8Array.from(binaryStr, c => c.charCodeAt(0));
    const jsonPayload = new TextDecoder().decode(bytes);

    return JSON.parse(jsonPayload) as T;
  } catch (error) {
    console.error('Failed to parse JWT:', error);
    return null;
  }
};
